<template>
  <v-layout column>
    <v-flex>
      <HeaderBar>
        <v-icon slot="icon">account_circle</v-icon>
          My Profile
      </HeaderBar>
    </v-flex>
    <v-flex v-if="gettingProfile">
      <v-progress-linear indeterminate></v-progress-linear>
    </v-flex>
    <v-flex v-else>
      <v-layout row>
        <v-flex mr-2>
          <v-text-field
            disabled
            label="First Name"
            :value="user.first_name"
          >
          </v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            disabled
            label="Last Name"
            :value="user.last_name"
          >
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex>
          <v-text-field
            :disabled="!updatingEmail"
            hint="This is your login. Only change this if you are sure it's correct, otherwise you will be locked out."
            label="Email / Login"
            v-model="email"
          >
          </v-text-field>
          <v-btn v-if="!updatingEmail" color="warning" @click="updatingEmail = !updatingEmail">Change Email</v-btn>
          <v-btn v-if="updatingEmail" :disabled="updatingProfile" :loading="updatingProfile" color="warning" @click="saveEmail">Lock Email</v-btn>
        </v-flex>
      </v-layout>
      <v-divider class="mt-4"></v-divider>
      <v-layout column class="mt-4">
        <v-flex xs2>
          <PasswordResetDialog :toSelf="true" :email="user.email" />
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12>
          <v-layout row v-for="(setting) in orderedMessagePreferences" :key="preferenceLabel(setting)">
            <v-checkbox
              v-if="!setting[Object.keys(setting)[0]].managerOverride"
              :key="Object.keys(setting)[0]"
              :label="preferenceLabel(setting)"
              v-model="setting[Object.keys(setting)[0]].userSetting"
              @change="updateMessagePreferences"
              v-show="showPref(setting)"
            />
            <v-checkbox
              v-else
              :key="Object.keys(setting)[0]"
              :label="`${ preferenceLabel(setting) } (manager override)`"
              v-model="setting[Object.keys(setting)[0]].managerOverride"
              v-show="showPref(setting)"
              disabled
            />
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 class="mt-3">
          <div class="subheading">Default calendar view</div>
          <v-radio-group v-model="defaultCalendarView" row>
            <v-radio label="List" value="list"></v-radio>
            <v-radio label="Month" value="month"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import PasswordResetDialog from '@/components/hr/password-reset-dialog.vue'

export default {
  components: {
    PasswordResetDialog
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    defaultCalendarView: {
      get () {
        return this.user.defaultCalendarView || 'list'
      },
      set (value) {
        this.$store.dispatch('userAuth/setDefaultCalendarView', value)
      },
    },
    orderedMessagePreferences() {
      const clientPrefs = Object.assign({},
        {
          pickup: this.profile.message_preferences.pickup,
          global: this.profile.message_preferences.global
        }
      )
      console.log(clientPrefs)
      const prefs = Object.entries(clientPrefs).map(([k, v]) => {
        return { [k]: v }
      })
      // move 'global' to the top of the list:
      return prefs.reduce((accum, pref) => {
        if (Object.keys(pref)[0] === 'global') {
          return [pref, ...accum]
        }
        return [...accum, pref]
      }, [])
    },
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  data: function () {
    return {
      profile: null,
      updatingEmail: false,
      receiveEmail: false,
      gettingProfile: false,
      updatingProfile: false,
      email: '',
    }
  },
  methods: {
    saveEmail () {
      this.updateProfile()
    },
    setUpComponentFromParams (params) {
      this.userId = params.userId
      this.email = params.email
      this.receiveEmail = params.receiveEmail
    },
    updateProfile () {
      this.updatingProfile = true
      this.$store.dispatch('clients/updateOwnProfile', {
        email: this.email,
      }).then(res => {
        this.setUpComponentFromParams(res)
        this.$store.dispatch("global/showSnackbarSuccess", { message: "Your profile has been updated!" })
      }).catch(err => {
        console.log(err)
        this.$store.dispatch("global/showSnackbarError", { message: "Something went wrong..." })
      }).finally(res => {
        this.updatingProfile = false
      })
    },
    updateReceiveEmail (value) {
      this.$store.dispatch("profiles/update", {
        receive_email: value
      })
      .then(profile => {
        this.receiveEmail = profile.receiveEmail
        let message
        if (value) {
          message = "You will get messages as emails"
        } else {
          message = "You'll no longer get messages as emails"
        }
        this.$store.dispatch("global/showSnackbarSuccess", { message: message })
      })
      .catch(e => {
        this.$store.dispatch("global/showSnackbarError", { message: "Something went wrong" })
      })
      .finally(r => {
      })
    },
    setUp () {
      this.getUserProfile()
    },
    getUserProfile () {
      this.gettingProfile = true
      this.$store.dispatch("profiles/get")
      .then(profile => {
        this.receiveEmail = profile.receiveEmail
        this.profile = profile
        this.setUpComponentFromParams(profile)
      })
      .finally(r => {
        this.gettingProfile = false
      })
    },
    showPref(setting) {
      const key = Object.keys(setting)[0]
      if (key === 'global') {
        return true
      }

      if (!this.receiveEmail) {
        return false
      } else {
        return true
      }
    },

    preferenceLabel(setting) {
      // get the key name from the settings object:
      const key = Object.keys(setting)[0]

      switch(key.toString()) {
        case 'global':
          return "Receive message emails";
        case 'shiftReminder':
          return "Shift reminders";
        case 'important':
          return "Important and time-sensitive messages";
        case 'pickup':
          return "Employee picked up shift";
        case 'default':
          return "All other messages";
      }
    },

    updateMessagePreferences() {
      this.$store.dispatch("profiles/update", {
        message_preferences: this.profile.message_preferences
      }).then(profile => {
        this.profile = profile
        this.$store.dispatch("global/showSnackbarSuccess", { message: "Message preferences updated" })
      })
      .catch(e => {
        this.$store.dispatch("global/showSnackbarError", { message: "Something went wrong" })
      })
    },
  },
}
</script>

<style scoped>
</style>
